import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\toverflow-y: auto;\n"]);

  _templateObject7 = function () {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\toverflow-x: hidden;\n\toverflow-y: auto;\n"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\toverflow-x: auto;\n\toverflow-y: hidden;\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tscroll-behavior: smooth;\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\theight: 100%;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t@media only screen and (min-device-width: 40em) {\n\t\t&::-webkit-scrollbar {\n\t\t\theight: 12px;\n\t\t\twidth: 12px;\n\t\t}\n\n\t\t&::-webkit-scrollbar-track {\n\t\t\tbackground-color: transparent;\n\t\t}\n\n\t\t&::-webkit-scrollbar-track {\n\t\t\tbackground: ", ";\n\t\t\tborder-radius: 8px;\n\t\t}\n\n\t\t&::-webkit-scrollbar-thumb {\n\t\t\tbackground-clip: padding-box;\n\t\t\tbackground-color: ", ";\n\t\t\tborder: 2px solid rgba(0, 0, 0, 0);\n\t\t\tborder-radius: 7px;\n\t\t}\n\n\t\t&:hover::-webkit-scrollbar-thumb {\n\t\t\tbackground-color: ", ";\n\t\t}\n\t}\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, ui } from '@wp-g2/styles';
export var scrollableScrollbar = css(_templateObject(), ui.get('colorScrollbarTrack'), ui.get('colorScrollbarThumb'), ui.get('colorScrollbarThumbHover'));
export var Scrollable = css(_templateObject2());
export var Content = css(_templateObject3());
export var smoothScroll = css(_templateObject4());
export var scrollX = css(_templateObject5());
export var scrollY = css(_templateObject6());
export var scrollAuto = css(_templateObject7());